import React from 'react';
import { Tabs } from 'antd';
import BotSetting from '../../Component/Setting/BotSetting';
// import SubsSetting from '../../Component/Setting/SubsSetting';

const { TabPane } = Tabs;

const MainSetting = () => {
  return (
    <Tabs defaultActiveKey="1">
      <TabPane tab="Main Setting" key="1">
        {/* <BotSetting /> */}
      </TabPane>
      <TabPane tab="Bot Setting" key="2">
        {/* <SubsSetting /> */}
        <BotSetting />
      </TabPane>
    </Tabs>
  );
};

export default MainSetting;
